"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteValue = exports.sitePagerSizes = exports.siteIconSizes = exports.siteSizes = exports.rem = exports.siteNumbers = exports.siteColors = exports.breakpoints = exports.buildLiteralStyles = void 0;

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Function builds a styled-components css 
 */
var buildLiteralStyles = function buildLiteralStyles(styles) {
  return (0, _styledComponents.css)(_templateObject(), Object.keys(styles).map(function (key) {
    return "".concat(key, ":").concat(styles[key]);
  }));
};

exports.buildLiteralStyles = buildLiteralStyles;
var breakpoints = {
  "sm": "576px",
  "md": "735px",
  "lg": "1068"
};
exports.breakpoints = breakpoints;
var siteColors = {
  //theme colors
  "dark-grey": "#828282",
  "default-grey": "#efeff0",
  "info-blue": "rgb(34, 167, 240)",
  "medium-grey": "#c4c4c4",
  "off": "#E53424",
  "on": "#01B420",
  "primary": "#007556",
  "primary-faded": "rgba(4, 149, 101, 0.09)",
  "secondary": "silver",
  "old-algo-green": "#1e824c"
};
exports.siteColors = siteColors;
var siteNumbers = {
  //theme multipliers
  text: 16,
  spacer1: 0.25,
  spacer2: 0.5,
  spacer3: 1,
  spacer4: 1.25,
  spacer5: 1.5,
  spacer6: 3,
  spacer7: 6,
  spacer8: 12,
  spacer9: 24,
  spacer10: 48
};
exports.siteNumbers = siteNumbers;
var rem = siteNumbers.text;
exports.rem = rem;
var siteSizes = {
  //theme sizes
  "border-radius": "4px",
  "round": "".concat(rem * siteNumbers.spacer3, "px"),
  "round-0": "0px",
  "round-1": "".concat(rem * siteNumbers.spacer1, "px"),
  "round-2": "".concat(rem * siteNumbers.spacer2, "px"),
  "round-3": "".concat(rem * siteNumbers.spacer3, "px"),
  "xsm": {
    width: "".concat(rem * siteNumbers.spacer5, "px"),
    height: "".concat(rem * 2, "px")
  },
  "sm": {
    width: "".concat(rem * siteNumbers.spacer6, "px"),
    height: "".concat(rem * 1.55, "px")
  },
  "md": {
    width: "".concat(rem * siteNumbers.spacer7, "px"),
    height: "".concat(rem * 2.25, "px")
  },
  "lg": {
    width: "".concat(rem * siteNumbers.spacer8, "px"),
    height: "".concat(rem * 3, "px")
  },
  "xlg": {
    width: "".concat(rem * siteNumbers.spacer9, "px"),
    height: "".concat(rem * 4, "px")
  }
};
exports.siteSizes = siteSizes;
var siteIconSizes = {
  "xs": "12px",
  "sm": "18px",
  "md": "24px",
  "lg": "30px",
  "xl": "36px"
};
exports.siteIconSizes = siteIconSizes;
var sitePagerSizes = {
  "width-control": "95px",
  "width-item": "64px",
  "padding-xs": "10px",
  "padding-sm": "14px",
  "padding-md": "".concat(siteNumbers.text * siteNumbers.spacer4, "px"),
  "padding-lg": "".concat(siteNumbers.text * siteNumbers.spacer5, "px")
};
exports.sitePagerSizes = sitePagerSizes;

var getSiteValue = function getSiteValue(object, choice) {
  if (choice !== null && choice !== undefined) {
    //if choice is a string
    var value = object[choice]; //check if value is in dictionary

    if (value !== null && value !== undefined) return value; //if it was, return it
    else return choice; //otherwise just return the string
  } else return ""; //if invalid value, return empty string

};

exports.getSiteValue = getSiteValue;